import { useCallback, useEffect, useMemo, useState } from 'react';
import { CrmScheduleService } from '@layouts/pages/CRM/kanban-board/services/crm-schedule.service';
import { authStorage } from 'functions/auth-session';
import { AgendaItemResponse } from '@layouts/pages/CRM/kanban-board/services/responses/lead-schedule.response';

/// O que pede ação agora (aberto vencido e de hoje); fonte única do contador do menu e do sino.
/// `refreshKey` recarrega quando muda: o menu vive a sessão inteira e o contador só atualizaria no F5.
export const usePending = (refreshKey?: string) => {
    const service = useMemo(() => new CrmScheduleService(), []);

    const [items, setItems] = useState<AgendaItemResponse[]>([]);

    const search = useCallback(async () => {
        const now = new Date();

        // Para trás só o que ainda cabe cobrar: agendamento antigo não fechado é histórico.
        const from = new Date(now);
        from.setDate(from.getDate() - 30);
        from.setHours(0, 0, 0, 0);

        const ate = new Date(now);
        ate.setHours(23, 59, 59, 999);

        // Só as minhas: somar compromissos dos colegas vira ruído e a pessoa para de olhar o número.
        const eu = authStorage.read()?.userId;

        if (!eu) {
            setItems([]);
            return;
        }

        try {
            const res = await service.agenda(from.toISOString(), ate.toISOString(), eu);

            setItems((res.data.data ?? []).filter((item) => !item.closedAt));
        } catch {
            // Sino e contador são acessórios: falhar aqui não pode derrubar a tela em uso.
            setItems([]);
        }
    }, [service]);

    useEffect(() => {
        search();
    }, [search, refreshKey]);

    const now = new Date();

    const overdue = items.filter((item) => new Date(item.scheduledAt) < now);
    const today = items.filter((item) => {
        const when = new Date(item.scheduledAt);

        return when >= now && when.toDateString() === now.toDateString();
    });

    return { atrasados: overdue, hoje: today, total: overdue.length + today.length, refetch: search };
};
